export const darkTheme = {
  // Base colors - Rich earthy backgrounds
  'bg-primary': '#1A1714',           // Deep brown-black
  'bg-secondary': '#242019',         // Rich soil brown
  'bg-tertiary': '#2D2823',          // Warm elevated brown

  // Text colors - Warm paper-like tones
  'text-primary': '#F5E6D3',         // Warm parchment white
  'text-secondary': 'rgba(245, 230, 211, 0.82)',
  'text-tertiary': 'rgba(245, 230, 211, 0.64)',

  // Action colors - Copper and brass tones
  'action-primary': '#C17F59',         // Warm copper
  'action-primary-hover': '#D4916A',   // Lighter copper
  'action-primary-light': 'rgba(193, 127, 89, 0.15)',
  'action-primary-border': 'rgba(193, 127, 89, 0.35)',

  // Button colors - Explorer-inspired gradients
  'button-primary': 'linear-gradient(180deg, #C17F59 0%, #A66D4B 100%)',
  'button-primary-hover': 'linear-gradient(180deg, #D4916A 0%, #C17F59 100%)',
  'button-secondary': '#242019',
  'button-secondary-hover': '#2D2823',
  'button-text': '#F5E6D3',
  'button-text-muted': 'rgba(245, 230, 211, 0.82)',

  // Interactive elements - Warm metallics
  'interactive-text': '#F5E6D3',
  'interactive-hover': '#D4916A',
  'interactive-muted': 'rgba(245, 230, 211, 0.64)',

  // Accent colors - Natural palette
  'accent-primary': '#C17F59',         // Copper
  'accent-secondary': '#739E82',       // Forest green
  'accent-tertiary': '#BF9B30',        // Antique brass
  'accent-muted': 'rgba(193, 127, 89, 0.16)',
  'accent-soft': 'rgba(115, 158, 130, 0.16)',

  // Borders - Aged leather look
  'border-primary': 'rgba(245, 230, 211, 0.12)',
  'border-secondary': 'rgba(245, 230, 211, 0.06)',

  // Status colors - Natural indicators
  'success': '#739E82',              // Forest green
  'warning': '#BF9B30',             // Antique brass
  'error': '#C25D5D',               // Terracotta red
  'info': '#7A92A3',                // Slate blue

  // Shadow effects - Deep natural shadows
  'shadow-sm': '0 2px 4px rgba(0, 0, 0, 0.5), 0 1px 2px rgba(0, 0, 0, 0.4)',
  'shadow-md': '0 4px 8px rgba(0, 0, 0, 0.5), 0 2px 4px rgba(0, 0, 0, 0.4)',
  'shadow-lg': '0 8px 16px rgba(0, 0, 0, 0.5), 0 4px 8px rgba(0, 0, 0, 0.4)',

  // Focus states
  'focus-ring': 'rgba(193, 127, 89, 0.6)',
  'focus-ring-offset': '#1A1714',

  // Modal and overlay colors
  'modal-backdrop': 'rgba(26, 23, 20, 0.8)',
  'modal-backdrop-filter': 'blur(20px)',
  'modal-bg': '#242019',
  'modal-border': 'rgba(245, 230, 211, 0.08)',

  // Surface overlays - Warm interactions
  'overlay-hover': 'rgba(245, 230, 211, 0.04)',
  'overlay-active': 'rgba(245, 230, 211, 0.06)',
  'overlay-raised': 'rgba(245, 230, 211, 0.08)'
};

export const lightTheme = {
  // Base colors - Vintage paper foundations
  'bg-primary': '#FBF7F1',         // Cream paper
  'bg-secondary': '#F5EDE3',       // Aged parchment
  'bg-tertiary': '#EDE3D5',        // Antique paper

  // Text colors - Aged ink tones
  'text-primary': '#2C1810',       // Deep brown ink
  'text-secondary': 'rgba(44, 24, 16, 0.82)',
  'text-tertiary': 'rgba(44, 24, 16, 0.64)',

  // Action colors - Matching dark theme copper
  'action-primary': '#A66D4B',     // Aged copper
  'action-primary-hover': '#C17F59',
  'action-primary-light': 'rgba(166, 109, 75, 0.12)',
  'action-primary-border': 'rgba(166, 109, 75, 0.25)',

  // Button colors - Vintage metallics
  'button-primary': 'linear-gradient(180deg, #A66D4B 0%, #956041 100%)',
  'button-primary-hover': 'linear-gradient(180deg, #C17F59 0%, #A66D4B 100%)',
  'button-secondary': '#F5EDE3',
  'button-secondary-hover': '#EDE3D5',
  'button-text': '#FBF7F1',
  'button-text-muted': 'rgba(44, 24, 16, 0.82)',

  // Interactive elements - Warm interactions
  'interactive-text': '#2C1810',
  'interactive-hover': '#A66D4B',
  'interactive-muted': 'rgba(44, 24, 16, 0.64)',

  // Accent colors - Natural palette
  'accent-primary': '#A66D4B',      // Aged copper
  'accent-secondary': '#5C8A6A',    // Sage green
  'accent-tertiary': '#A68B47',     // Aged brass
  'accent-muted': 'rgba(166, 109, 75, 0.12)',
  'accent-soft': 'rgba(92, 138, 106, 0.12)',

  // Borders - Aged paper edges
  'border-primary': 'rgba(44, 24, 16, 0.12)',
  'border-secondary': 'rgba(44, 24, 16, 0.06)',

  // Status colors - Natural indicators
  'success': '#5C8A6A',            // Sage green
  'warning': '#A68B47',           // Aged brass
  'error': '#B54B4B',            // Faded red
  'info': '#617C8C',             // Dusty blue

  // Shadow effects - Soft parchment shadows
  'shadow-sm': '0 2px 4px rgba(44, 24, 16, 0.04), 0 1px 2px rgba(44, 24, 16, 0.06)',
  'shadow-md': '0 4px 6px rgba(44, 24, 16, 0.04), 0 2px 4px rgba(44, 24, 16, 0.06)',
  'shadow-lg': '0 8px 12px rgba(44, 24, 16, 0.04), 0 3px 6px rgba(44, 24, 16, 0.06)',

  // Focus states
  'focus-ring': 'rgba(166, 109, 75, 0.4)',
  'focus-ring-offset': '#FBF7F1',

  // Modal and overlay colors
  'modal-backdrop': 'rgba(44, 24, 16, 0.3)',
  'modal-backdrop-filter': 'blur(16px)',
  'modal-bg': '#FBF7F1',
  'modal-border': 'rgba(44, 24, 16, 0.08)',

  // Surface overlays - Warm paper interactions
  'overlay-hover': 'rgba(44, 24, 16, 0.02)',
  'overlay-active': 'rgba(44, 24, 16, 0.04)',
  'overlay-raised': 'rgba(44, 24, 16, 0.06)'
};

// Helper functions remain unchanged
export const getColorWithOpacity = (color, opacity) => {
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  return color;
};

export const adjustColor = (color, amount) => {
  const clamp = (num) => Math.min(255, Math.max(0, num));
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    const newR = clamp(r + amount);
    const newG = clamp(g + amount);
    const newB = clamp(b + amount);
    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
  }
  return color;
};